import { inject } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';
import { AuthService }  from "../auth/auth.service";

export const isAuthenticatedGuard: CanActivateFn = async() => {

  console.log('hello')

  const authService =  inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = await  authService.isAuthenticated()

  console.log('isAuth', false)
  if(false) {
    router.navigate(['./']);
    false
  }

  return true
}
